"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _UISearchInput = _interopRequireDefault(require("UIComponents/input/UISearchInput"));

var _Constants = require("../../Constants");

var _Actions = require("../../actions/Actions");

var _Configuration = require("../../selectors/Configuration");

var SearchWithSuggestions = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SearchWithSuggestions, _Component);

  function SearchWithSuggestions() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SearchWithSuggestions);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SearchWithSuggestions)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      searchQuery: ''
    };

    _this.handleSearchChange = function (event) {
      _this.setState({
        searchQuery: event.target.value
      });
    };

    _this.handleSearchKeyUp = function (event) {
      var searchQuery = _this.state.searchQuery;

      if (event.key === 'Enter' && searchQuery) {
        _this.props.enterSearchPanel(searchQuery);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(SearchWithSuggestions, [{
    key: "getPlaceholder",
    value: function getPlaceholder() {
      var type = this.props.type;

      switch (type) {
        case _Constants.DrawerTypes.IMAGE:
          return _I18n.default.text('FileManagerLib.searchImagesPlaceholder');

        case _Constants.DrawerTypes.VIDEO:
        case _Constants.DrawerTypes.HUBL_VIDEO:
          return _I18n.default.text('FileManagerLib.searchVideosPlaceholder');

        default:
          return _I18n.default.text('FileManagerLib.searchFilesPlaceholder');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var searchQuery = this.state.searchQuery;
      return _react.default.createElement(_UISearchInput.default, {
        className: "m-top-3",
        value: searchQuery,
        placeholder: this.getPlaceholder(),
        onChange: this.handleSearchChange,
        onKeyUp: this.handleSearchKeyUp,
        "data-test-id": "drawer-search-input"
      });
    }
  }]);
  return SearchWithSuggestions;
}(_react.Component);

SearchWithSuggestions.propTypes = {
  type: _propTypes.default.oneOf(Object.keys(_Constants.DrawerTypes)).isRequired,
  enterSearchPanel: _propTypes.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hostApp: (0, _Configuration.getHostApp)(state)
  };
};

var mapDispatchToProps = {
  enterSearchPanel: _Actions.enterSearchPanel
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchWithSuggestions);

exports.default = _default;
module.exports = exports.default;